import API_URLS from '../../../../config/apiConfig';
import { apiGet, apiPost } from '../../../../utils/apiUtils';
import type {
    StoreDetailsCreateNotificationPayload,
    StoreDetailsNotificationResponse,
} from '../../../../types/features/storeDetails/notifications';

class StoreDetailsNotificationsService {
    async getStoreNotifications(storeId: string): Promise<StoreDetailsNotificationResponse[]> {
        const response = await apiGet(API_URLS.GET_STORE_NOTIFICATIONS(storeId));

        return Array.isArray(response) ? response as StoreDetailsNotificationResponse[] : [];
    }

    async createStoreNotification(payload: StoreDetailsCreateNotificationPayload): Promise<unknown> {
        return apiPost(API_URLS.CREATE_NOTIFICATION, payload);
    }
}

const storeDetailsNotificationsService = new StoreDetailsNotificationsService();

export default storeDetailsNotificationsService;
